import $ from 'jquery';

export default function () {
    $(document).ready(() => {
        // Cached elements
        var $social = $('.social');
        var $more = $social.find('.more');
        var $popUp = $social.find('.share-popup');
        var $body = $('body');

        function toggleMenu(e) {
            e.stopPropagation();
            e.preventDefault();
            let ind = $more.index($(this));

            $($popUp[ind]).toggleClass('_active');
        }

        function closeTips() {
            $popUp.removeClass('_active');
        }
        /**
         * Initializes Po;;
         * @return {void}
         */

        $more.on('click', toggleMenu);
        $body.on('click', closeTips);
    });
}
